import globalState from "../global-state";

import { fetchWrapper } from "../../utils/fetchWrapper";
import { router } from "../../App";

export interface LeadState {
    url: string
    leadId: string
    mensagemDeErro?: string
    hasNumeroProposta: boolean
}

export const getLeadFetch = () =>
    fetchWrapper<LeadState>("/api/Lead");

export const saveLeadFetch = (leadId: string, numeroProposta: string, valorProposta: number, parcelas: number, periodicidade: string) =>
    fetchWrapper(
        "/api/Lead/Save", 
        {
            method: "POST",
            body: JSON.stringify({
                leadId: leadId,
                numeroProposta: numeroProposta,
                valorProposta: valorProposta,
                parcelas: parcelas,
                periodicidade: periodicidade
            })
        });

export const saveLead = async (numeroProposta: string, valorProposta: number, parcelas: number, periodicidade: string) => {
    globalState.isLoading.set(true)

    const leadId = globalState.leadState.leadId.get()
    await saveLeadFetch(leadId, numeroProposta, valorProposta, parcelas, periodicidade);

    globalState.leadState.hasNumeroProposta.set(true);
    globalState.isLoading.set(false)
}

export const gotoLead = async () => {
    globalState.isLoading.set(true)
    
    const response = await getLeadFetch();

    globalState.leadState.set(response);
    
    await router.navigate("/lead", { replace: true });

    globalState.isLoading.set(false)
}



